import { REVIEW_TYPE } from './components/constants';

export const reviewDataProperties = {
  id: 'Id',
  type: 'Type',
  recommendationType: 'RecommendationType',
  reviewText: 'Text',
  createdTime: 'CreatedTime',
  updatedTime: 'UpdatedTime',
  reviewer: 'Reviewer',
};

export const reviewerDataProperties = {
  name: 'Name',
  picture: 'PictureUrl',
  fbPictureSrc: 'FbPictureUrl',
  imageId: 'ImageId',
};

export const convertModelToConfig = (mtModel) => {
  const result = {
    id: mtModel[reviewDataProperties.id],
    type: mtModel[reviewDataProperties.type] || REVIEW_TYPE.FACEBOOK_REVIEW,
    recommendationType: mtModel[reviewDataProperties.recommendationType],
    reviewText: mtModel[reviewDataProperties.reviewText],
    createdTime: mtModel[reviewDataProperties.createdTime],
    updatedTime: mtModel[reviewDataProperties.updatedTime],
  };

  const reviewer = mtModel[reviewDataProperties.reviewer];
  if (reviewer) {
    result.reviewer = {
      name: reviewer[reviewerDataProperties.name],
      picture: reviewer[reviewerDataProperties.picture],
      fbPictureSrc: reviewer[reviewerDataProperties.fbPictureSrc],
      imageId: reviewer[reviewerDataProperties.imageId],
    };
  }

  return result;
};

export const covertConfigToModel = (config) => {
  const result = {
    [reviewDataProperties.id]: config.id,
    [reviewDataProperties.type]: config.type || REVIEW_TYPE.FACEBOOK_REVIEW,
    [reviewDataProperties.recommendationType]: config.recommendationType,
    [reviewDataProperties.reviewText]: config.reviewText,
    [reviewDataProperties.createdTime]: config.createdTime,
    [reviewDataProperties.updatedTime]: config.updatedTime,
  };

  const { reviewer } = config;
  if (reviewer) {
    result[reviewDataProperties.reviewer] = {
      [reviewerDataProperties.name]: reviewer.name,
      [reviewerDataProperties.picture]: reviewer.picture,
      [reviewerDataProperties.fbPictureSrc]: reviewer.fbPictureSrc,
      [reviewerDataProperties.imageId]: reviewer.imageId,
    };
  }

  return result;
};
